export const StaticText = {
    environmentalSetup: 'Environmental Setup'
}